function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
import { useShowToast } from '@rd-web-markets/shared/dist/util/toast/useToast';
import { useTranslation } from 'react-i18next';
const api = buildService('/elsters/{id}/project_elster_details', {
  only: ['update']
});
const projectElsterDetailService = {
  useUpdate: (elsterId, projectElsterDetailId, setSelectedProject) => {
    const {
      t
    } = useTranslation();
    const showToast = useShowToast();
    const updateProjectElsterDetail = serviceMethods.useUpdate({
      callback: useCallback(async projectElsterDetail => {
        const response = await api.update(elsterId, projectElsterDetailId, {
          project_elster_detail: projectElsterDetail
        });
        setSelectedProject(prev => _objectSpread(_objectSpread({}, prev), {}, {
          project_elster_detail: _objectSpread(_objectSpread({}, prev.project_elster_detail), {}, {
            type_of_research: response.type_of_research
          })
        }));
        showToast({
          message: t('changes_saved')
        });
      }, [elsterId, projectElsterDetailId, setSelectedProject, showToast, t])
    });
    return [updateProjectElsterDetail];
  }
};
projectElsterDetailService.useCrud = (elsterId, projectElsterDetailId, setSelectedProject) => {
  const [updateProjectElsterDetail] = projectElsterDetailService.useUpdate(elsterId, projectElsterDetailId, setSelectedProject);
  return {
    updateProjectElsterDetail
  };
};
export default projectElsterDetailService;